var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarketingHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 139 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.642 18.806a9.403 9.403 0 100-18.806 9.403 9.403 0 000 18.806zm26.716 2.68a9.403 9.403 0 0012.845-3.442A9.402 9.402 0 0097.761 5.2a9.403 9.403 0 00-9.403 16.287zm34.643 19.124a9.403 9.403 0 01-12.845-3.442 9.402 9.402 0 013.442-12.844 9.402 9.402 0 0112.844 3.441 9.403 9.403 0 01-3.441 12.845zm-1.809 21.032a9.403 9.403 0 1018.806 0 9.403 9.403 0 00-18.806 0zm-2.678 26.72a9.404 9.404 0 1016.289 9.402 9.404 9.404 0 00-16.289-9.402zm-19.12 34.639a9.403 9.403 0 013.442-12.845 9.401 9.401 0 0112.844 3.442 9.402 9.402 0 01-3.441 12.844 9.403 9.403 0 01-12.845-3.441zm-21.04-1.807a9.403 9.403 0 100 18.806 9.403 9.403 0 000-18.806zm-39.557.762a9.404 9.404 0 1116.287 9.405 9.404 9.404 0 01-16.287-9.405zM16.999 99.39a9.403 9.403 0 0112.845 3.442 9.402 9.402 0 01-3.442 12.844 9.403 9.403 0 01-12.844-3.441c-2.597-4.498-1.056-10.249 3.441-12.845zm1.807-21.032a9.403 9.403 0 10-18.806 0 9.403 9.403 0 0018.806 0zm-.758-39.565a9.403 9.403 0 11-9.403 16.286 9.403 9.403 0 019.403-16.286zm19.118-8.949a9.403 9.403 0 10-9.403-16.286 9.403 9.403 0 009.403 16.286z",
    fill: "currentColor"
  })));
}

export default SvgMarketingHome;